var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Плановые платежи")]),
      _vm._v(" "),
      _c("tableOperations", {
        attrs: { items: _vm.items },
        on: {
          "update-operations-table": function ($event) {
            return _vm.getItems(_vm.operationDefault.task)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-button",
        {
          on: {
            click: function ($event) {
              return _vm.getItems(_vm.operationDefault.task)
            },
          },
        },
        [_vm._v("Обновить данные")]
      ),
      _vm._v(" "),
      _c("h5", [_vm._v("Добавить плановый платеж")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("addOperation", {
            attrs: { operationDefault: _vm.operationDefault, mode: "add" },
            on: {
              "update-operations-table": function ($event) {
                return _vm.getItems(_vm.operationDefault.task)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }